__turbopack_context__.v({
  "indicator": "Toggle-module-sass-module__wJXDTG__indicator",
  "label": "Toggle-module-sass-module__wJXDTG__label",
  "option": "Toggle-module-sass-module__wJXDTG__option",
  "toggle": "Toggle-module-sass-module__wJXDTG__toggle" + " " + __turbopack_context__.i(91123)["button"],
  "wrapper": "Toggle-module-sass-module__wJXDTG__wrapper",
});
